import { MouseEventHandler, ReactNode } from 'react';
import styled from 'styled-components';

import Spinner from 'packages/kakapo-ui-kit/components/common/Spinner';
import { toRgbString } from 'packages/kakapo-ui-kit/helpers/HexColor';

export interface IProps {
	block?: boolean;
	onClick?: MouseEventHandler<HTMLElement>;
	onMouseDown?: MouseEventHandler<HTMLElement>;
	size: ButtonSize;
	children: ReactNode;
	isLoading?: boolean;
	enabled?: boolean;
}

export enum ButtonSize {
	Small = 28,
	Medium = 32,
	Large = 40,
}

const ButtonContainer = styled.button<IProps>`
	font-weight: 600;
	background-color: rgba(${(props) => toRgbString(props.theme.colors.primary)}, 0.15);
	height: 32px;
	height: ${(props) => props.size}px;
	color: ${(props) => props.theme.colors.primary};
	border-radius: ${(props) => props.size / 2}px;
	transition: background-color 150ms ease-out;

	${(props) => props.block && `display: block; width: 100%;`}

	padding: 8px 16px;

	${(props) =>
		props.enabled
			? `
		&:hover {
			background-color: ${props.theme.colors.primary};
			color: ${props.theme.colors.white};
		}
	`
			: `
		cursor: default;
		background-color: rgba(${toRgbString(props.theme.colors.slateBlue)}, 0.15);
		color: ${props.theme.colors.slateBlue};
	`}
`;

export default function Button({
	block,
	onClick,
	onMouseDown,
	size = ButtonSize.Small,
	children,
	isLoading,
	enabled,
}: IProps) {
	return (
		<ButtonContainer
			block={block}
			size={size}
			onMouseDown={onMouseDown}
			onClick={(enabled ?? true) && !isLoading ? onClick : undefined}
			enabled={enabled ?? true}
		>
			{isLoading ? <Spinner verticalMargin={-3} size="18px" isLoading /> : <>{children}</>}
		</ButtonContainer>
	);
}
